import { render } from "./TimeStamp.vue?vue&type=template&id=3d4c7b62"
import script from "./TimeStamp.vue?vue&type=script&lang=js"
export * from "./TimeStamp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__